import { useQuery } from "@tanstack/react-query";
import api from "../../api/api";
import { ME_QUERY_KEY } from "../../api/queryKeys";
import { QueryMeResponse } from "../../types";

export const getMeData = () =>
  api.get<QueryMeResponse>(ME_QUERY_KEY).then((res) => res.data);

export default function useGetMe() {
  return useQuery([ME_QUERY_KEY], getMeData);
}
